module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/highvoltage-f41e4dad3424a9b39d64a18bbc2451d7.svg";